import * as React from 'react'

import SignUpRequestForm from './SignUpRequestForm'

const SignUpRequestView = () => (
    <SignUpRequestForm />
)

export default SignUpRequestView
